import React from "react";
import { Form } from "react-bootstrap";
import { countries } from "./countries";
import { Location, US_STATES } from "./intake";

/** "Where does this apply?": a country and, optionally, a state or region. */
export default function LocationFields({
  value,
  onChange,
  idPrefix,
}: {
  value: Location;
  onChange: (next: Location) => void;
  idPrefix: string;
}) {
  const us = value.country === "US";
  return (
    <>
      <Form.Group controlId={`${idPrefix}-country`}>
        <Form.Label>Where does this apply?</Form.Label>
        <Form.Select
          value={value.country}
          onChange={e => onChange({ country: e.target.value, region: "" })}
        >
          <option value="">I’m not sure</option>
          {countries.map(c => (
            <option key={c.code} value={c.code}>
              {c.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      {value.country && (
        <Form.Group controlId={`${idPrefix}-region`}>
          <Form.Label>{us ? "State" : "State or region"}</Form.Label>
          {us ? (
            <Form.Select
              value={value.region}
              onChange={e => onChange({ ...value, region: e.target.value })}
            >
              <option value="">Whole country</option>
              {US_STATES.map(state => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </Form.Select>
          ) : (
            <Form.Control
              maxLength={200}
              value={value.region}
              placeholder="Optional"
              onChange={e => onChange({ ...value, region: e.target.value })}
            />
          )}
        </Form.Group>
      )}
    </>
  );
}
